import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';

import { CrossCollectionSelectorComponent } from './cross-collection-selector.component';

@NgModule({
  declarations: [CrossCollectionSelectorComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatSelectModule],
  exports: [CrossCollectionSelectorComponent]
})
export class CrossCollectionSelectorModule {}
